module.exports = __webpack_public_path__ + "img/building.75724196.png";